import { type SVGProps } from "react"

interface IconProps extends SVGProps<SVGSVGElement> {
  viewBox?: string
}

export function IconBase({
  children,
  viewBox = "0 0 24 24",
  ...props
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      fill="currentColor"
      width="1em"
      height="1em"
      {...props}
    >
      {children}
    </svg>
  )
}
